export const EMPLOYERS_FILTERS_INITIAL_VALUES = {
  keywords: '',
}
